import React from "react";
import { FunctionField, ReferenceField, SelectInput, Tab, TextField } from "react-admin";

import { DateFormatField } from "../../../components/fields/DateFormatField";
import { DocumentsFieldBlock } from "../../../components/fields/DocumentsField";
import { ReferenceEditableField } from "../../../components/fields/EditableField";
import { PriorityField } from "../../../components/fields/PriorityField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { UserFullNameReferenceField } from "../../../components/fields/UserFullNameReferenceField";
import { FlexLayout, FlexRow } from "../../../components/FlexShowLayout";
import { HistoryField } from "../../../components/HistoryGrid";
import { AppManagerRoles, UserRole } from "../../../entities";
import { TaskServiceNames } from "../../../entities/TaskService";
import { isInArray } from "../../../utils/general";
import { TaskHistoryGrid } from "./HistoryGrid";

export const GeneralTab = ({ permissions, ...props }) => {
	const isAppManager = permissions && isInArray(AppManagerRoles, permissions.role);

	return (
		<Tab label="General" {...props}>
			<FlexLayout>
				<FlexRow>
					<TextField source="id" />
					<TextField source="title" />
					<TextField source="rank" />
					<TextField source="rank_auto" />

					<SelectEnumField sortable={false} source="service" enumObj={TaskServiceNames} translate={false} reverse />

					<ReferenceEditableField
						editable={isAppManager}
						source="status"
						reference="task-statuses"
						editField={<SelectInput optionText="name" />}
					>
						<TextField source="short_name" />
					</ReferenceEditableField>

					<PriorityField source="priority" />

					<ReferenceField source="terminal_id" reference="terminal" link={false}>
						<TextField label="Terminal" source="name" />
					</ReferenceField>
				</FlexRow>

				<FlexRow>
					<DateFormatField source="eta_date" />
					<TextField source="eta_time" />
					<DateFormatField source="etd_date" />
					<TextField source="etd_time" />
				</FlexRow>

				<FlexRow>
					<TextField source="notes" />
					<TextField source="description" />
				</FlexRow>
			</FlexLayout>
		</Tab>
	);
};

export const HistoryTab = (props) => (
	<Tab label="Task History" {...props}>
		<UserFullNameReferenceField label="resources.entity-editlog.created_by" />
		<HistoryField label="resources.task-history.name" reference="task-history" target="original_id">
			<TaskHistoryGrid />
		</HistoryField>
	</Tab>
);

export const DocumentsTab = ({ isOSFCManager, isCustomerAsTrans, ...props }) => {
	return (
		<Tab label="Documents" {...props}>
			<FlexLayout>
				<FlexRow>
					<TextField source="id" />
					<TextField source="reference" />
					<ReferenceEditableField
						editable={isOSFCManager}
						source="status"
						reference="task-statuses"
						editField={<SelectInput optionText="name" />}
					>
						<TextField source="short_name" />
					</ReferenceEditableField>
				</FlexRow>
			</FlexLayout>
			<DocumentsFieldBlock
				variant="elevation"
				isCustomerAsTrans={isCustomerAsTrans}
				isOutputDocuments={false}
			/>
		</Tab>
	);
};
